// extracted by mini-css-extract-plugin
export default {"root":"FW5pzMJmw6iuIwtifMqb","icon":"uoR8WAZkWrJHoqBmJfqu"};